// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Debounce = require("../rescript-debounce/Debounce.bs.js");

let make = Debounce.make;

let makeControlled = Debounce.makeControlled;

exports.make = make;
exports.makeControlled = makeControlled;
/* No side effect */
